var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "162px",
    height: "126px",
    viewBox: "0 0 162 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-7u5_b9cly2-1",
    points: "0 0 126 0 126 126 0 126"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7u5_b9cly2-3",
    points: "0 126 162 126 162 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SurveyReel-UK",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---Full",
    transform: "translate(-269, -1496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "How-it-Works-Section",
    transform: "translate(0, 1215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(187, 203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-signup",
    transform: "translate(82, 78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7u5_b9cly2-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7u5_b9cly2-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.749472,115.081085 C120.749472,118.22997 118.22929,120.750166 115.080423,120.750166 L10.9177655,120.750166 C7.76889784,120.750166 5.25052843,118.22997 5.25052843,115.081085 L5.25052843,36.5600492 L5.25052843,31.9671693 L5.25052843,10.9178283 C5.25052843,7.76894252 7.76889784,5.24874685 10.9177655,5.24874685 L115.080423,5.24874685 C118.22929,5.24874685 120.749472,7.76894252 120.749472,10.9178283 L120.749472,115.081085 Z M115.080423,0 L10.9177655,0 C4.8283845,0 0,4.82841227 0,10.9178283 L0,115.081085 C0,121.170501 4.8283845,126.000725 10.9177655,126.000725 L115.080423,126.000725 C121.169804,126.000725 126,121.170501 126,115.081085 L126,10.9178283 C126,4.82841227 121.169804,0 115.080423,0 L115.080423,0 Z",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-7u5_b9cly2-2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7u5_b9cly2-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7u5_b9cly2-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3585261,107.229504 L105.643281,107.229504 L105.643281,95.9197708 L20.3585261,95.9197708 L20.3585261,107.229504 Z M17.7840488,111 L108.214145,111 C109.711858,111 111,110.095573 111,109.040115 L111,93.9616416 C111,92.9044274 109.711858,92 108.214145,92 L17.7840488,92 C16.2863353,92 15,92.9044274 15,93.9616416 L15,109.040115 C15,110.095573 16.2863353,111 17.7840488,111 L17.7840488,111 Z",
    id: "Fill-4",
    fill: "#DF4F71",
    mask: "url(#mask-7u5_b9cly2-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5283222,38.4354458 L54.469883,38.4354458 L54.469883,24.7454002 L38.5283222,24.7454002 L38.5283222,38.4354458 Z M36.3547993,43 L56.6434058,43 C57.9123412,43 59,41.904073 59,40.6254914 L59,22.3727001 C59,21.0941186 57.9123412,20 56.6434058,20 L36.3547993,20 C35.085864,20 34,21.0941186 34,22.3727001 L34,40.6254914 C34,41.904073 35.085864,43 36.3547993,43 L36.3547993,43 Z",
    id: "Fill-6",
    fill: "#A3A3A3",
    mask: "url(#mask-7u5_b9cly2-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5283222,38.4354458 L89.469883,38.4354458 L89.469883,24.7454002 L73.5283222,24.7454002 L73.5283222,38.4354458 Z M71.3547993,43 L91.6434058,43 C92.9123412,43 94,41.904073 94,40.6254914 L94,22.3727001 C94,21.0941186 92.9123412,20 91.6434058,20 L71.3547993,20 C70.085864,20 69,21.0941186 69,22.3727001 L69,40.6254914 C69,41.904073 70.085864,43 71.3547993,43 L71.3547993,43 Z",
    id: "Fill-7",
    fill: "#A3A3A3",
    mask: "url(#mask-7u5_b9cly2-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5981047,70 L48.403726,70 C47.109412,70 46,71.1542857 46,72.4990476 C46,73.847619 47.109412,75 48.403726,75 L94.5981047,75 C95.890588,75 97,73.847619 97,72.4990476 C97,71.1542857 95.705686,70 94.5981047,70",
    id: "Fill-8",
    fill: "#A3A3A3",
    mask: "url(#mask-7u5_b9cly2-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6349001,80 L48.3632986,80 C47.0897833,80 46,81.1528201 46,82.5 C46,83.8471799 47.0897833,85 48.3632986,85 L75.6349001,85 C76.9084154,85 78,83.8471799 78,82.5 C77.8180692,80.9622713 76.7264847,80 75.6349001,80",
    id: "Fill-9",
    fill: "#A3A3A3",
    mask: "url(#mask-7u5_b9cly2-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#E63946",
    mask: "url(#mask-7u5_b9cly2-4)",
    points: "19 109 111 109 111 94 19 94"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-11",
    stroke: "#158A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-7u5_b9cly2-4)",
    points: "38 75 29.7463415 84 26 79.9148936"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-12",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-7u5_b9cly2-4)",
    points: "14 63 43 63 43 51 14 51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-13",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-7u5_b9cly2-4)",
    points: "49 63 78 63 78 51 49 51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-14",
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-7u5_b9cly2-4)",
    points: "86 63 115 63 115 51 86 51"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    mask: "url(#mask-7u5_b9cly2-4)",
    fill: "#A8DADC"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(85, 14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06293962,68.9857365 L19.1291745,66.3804387 L9.76052688,57.0159415 L7.06293962,68.9857365 Z M14.8276165,56.1596548 L62.527521,8.48088218 L59.1555369,5.11039195 L11.4374055,52.7891646 L14.8276165,56.1596548 Z M23.2666901,64.5949898 L70.9665946,16.9162172 L65.4802854,11.4323385 L17.7803809,59.1111111 L23.2666901,64.5949898 Z M75.4504221,15.4040513 C76.1977267,16.2421191 76.1977267,17.5903152 75.3592874,18.3555076 L24.7066185,68.9857365 C24.6154838,69.1679252 24.4514413,69.2408007 24.2873988,69.331895 C24.2873988,69.4047705 24.1962641,69.4047705 24.1962641,69.4047705 C24.0322217,69.4958648 23.941087,69.5869591 23.7770445,69.5869591 L23.6859098,69.5869591 L5.36783411,73.7226417 L3.6727286,75.3987774 C3.25350896,75.8360302 2.67024685,76 2.1598925,76 C1.64953816,76 1.06627605,75.8360302 0.628829463,75.325902 C-0.209609821,74.5607096 -0.209609821,73.2125135 0.628829463,72.3744456 L2.32393497,70.6800911 L6.46145057,52.2790363 L6.46145057,52.2061609 C6.55258528,52.0239722 6.55258528,51.9510967 6.62549304,51.7689081 C6.71662774,51.7689081 6.71662774,51.6960326 6.71662774,51.6960326 C6.80776245,51.5138439 6.88067021,51.4409685 7.06293962,51.2769987 L57.7156086,0.628550881 C58.4811401,-0.20951696 59.8299337,-0.20951696 60.668373,0.628550881 L75.4504221,15.4040513 Z",
    id: "Fill-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    points: "70.9665946 16.9162172 23.2666901 64.5949898 17.7803809 59.1111111 65.4802854 11.4323385"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    points: "62.527521 8.48088218 14.8276165 56.1596548 11.4374055 52.7891646 59.1555369 5.11039195"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    points: "19.1291745 66.3804387 7.06293962 68.9857365 9.76052688 57.0159415"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M108.261702,78.6057163 L102.773565,73.1199171 L150.477165,25.4366434 L155.965303,30.9224426 L108.261702,78.6057163 Z M92.0506439,82.99472 L94.7518794,71.0101344 L104.124182,80.3784438 L92.0506439,82.99472 Z M144.145119,19.1054735 L147.522575,22.4814901 L99.8189743,70.1665858 L96.4415186,66.7905692 L144.145119,19.1054735 Z M160.440021,29.4029618 L145.665247,14.6326615 C144.821339,13.7891128 143.470721,13.7891128 142.710657,14.6326615 L92.0506439,65.2710884 C91.8811331,65.4405269 91.7972891,65.5243352 91.7134451,65.6937737 C91.7134451,65.6937737 91.7134451,65.777582 91.6277784,65.777582 C91.5439344,65.9470205 91.5439344,66.0308288 91.4600904,66.2002673 L91.4600904,66.2840756 L87.3225704,84.6818174 L85.6329312,86.3707366 C84.7890229,87.2142853 84.7890229,88.5643275 85.6329312,89.3240679 C86.0557967,89.8305615 86.6463502,90 87.1530597,90 C87.6597692,90 88.2503227,89.8305615 88.6731882,89.4078762 L90.3628274,87.7207789 L108.684568,83.5850219 L108.768412,83.5850219 C108.937923,83.5850219 109.021767,83.5012136 109.191277,83.4155834 C109.191277,83.4155834 109.275121,83.4155834 109.275121,83.3317751 C109.444632,83.2479668 109.61232,83.1623366 109.696164,82.99472 L160.356177,32.3562931 C161.200085,31.5965527 161.200085,30.2465105 160.440021,29.4029618 L160.440021,29.4029618 Z",
    id: "Fill-20",
    fill: "#000000",
    mask: "url(#mask-7u5_b9cly2-4)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureSignup);
export default __webpack_public_path__ + "static/media/feature-signup.0dd0423eb0c85d7ffebb4ac99e9d32c8.svg";
export { ForwardRef as ReactComponent };